"use client";

import { ErrorScreen, type ErrorScreenProps } from "@rmh/ui";

export default function Error({ error }: ErrorScreenProps) {
  return <ErrorScreen error={error} />;
}
